import React from 'react';
import './styles/Popup.css'; // Make sure to create this file

const Popup = ({ trigger, setTrigger, children }) => {
  return (
    <div className={`popup-overlay ${trigger ? 'active' : ''}`} onClick={() => setTrigger(false)}>
      <div className={`popup-content ${trigger ? 'active' : ''}`} onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={() => setTrigger(false)}>&times;</button>
        {children}
      </div>
    </div>
  );
};

export default Popup;